// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bEaU","col":"styles_col__2mfod"};